import {useTranslation} from "react-i18next";
import SelectCustom from "@ui/select/selectCustom/SelectCustom";
import {DEFAULT_DATA_SELECT_PER_PAGE} from "@constants/params";
import {FC} from "react";

interface IProps {
    perPage: number,
    setPerPage: (page: number) => void,
    setPage: (page: number) => void,

    disabled?: boolean,
    width?: number | string | { xs?: number | string, lg: number | string },
    data?: {
        value: string,
        label: string
    } [],
    size?: 'small'
}

const SelectPerPage: FC<IProps> = ({
                                       perPage,
                                       setPage,
                                       setPerPage,
                                       disabled,
                                       width,
                                       data,
                                       size,
                                   }) => {

    const {t} = useTranslation()
    const handleChange = (value: string) => {
        setPage(1);
        setPerPage(Number(value))
    }

    return (
        <SelectCustom
            width={width}
            disabled={disabled}
            onChange={handleChange}
            value={perPage?.toString()}
            data={data ?? DEFAULT_DATA_SELECT_PER_PAGE}
            label={t('showPage')}
            size={size}

        />
    );
};
export default SelectPerPage